import * as angular from 'angular'
import { GiftCardsResource } from './gift-cards-resource.service'

/**
 * Resource for querying the products API.
 */
angular
  .module('webregister.components')
  .service('giftCardsResource', GiftCardsResource)
